/* eslint-disable no-useless-concat */
import { DetailsGCFData, DetailsNonGCFData, RowType, TType } from "../types"
import { percentanceFormat, netFormat } from "../helpers/formatters"
import { NameRenderer } from "../components/SharedComponents/NameRenderer"
import { EntityNameRenderer } from "../components/SharedComponents/EntityNameRenderer"
import { getTableCells } from "./sharedCells"
import { RowDefinitionType } from "../components/SharedComponents/BaseTable"

// row for tables in map view

export const clientsRow = (t: TType) => {
  return [
    {
      name: "entityName",
      header: t("revenue.client"),
      render: (row: RowType) => <NameRenderer type="client" row={row} />,
      align: "start",
    },
    ...getTableCells(t),
  ]
}

export const brandsRow = (t: TType) => {
  return [
    {
      name: "entityName",
      header: t("revenue.brand"),

      render: (row: RowType) => <NameRenderer type="brand" row={row} />,
      align: "start",
    },
    ...getTableCells(t),
  ]
}

export const marketsRow = (t: TType) => {
  return [
    {
      name: "entityName",
      header: t("revenue.market"),
      render: (row: RowType) => <NameRenderer type="market" row={row} />,
      align: "start",
    },
    ...getTableCells(t),
  ]
}

export const nonGCFRow = (t: TType, type: string) => {
  return [
    {
      name: "entityName",
      header: "",
      render: (row: DetailsNonGCFData, rowId: number) => (
        <EntityNameRenderer type={type} row={row} rowId={rowId} />
      ),
      customWidth: 100,
      align: "start",
    },
    {
      name: "budRev",
      header: t("revenue.net.rev"),
      render: (row: DetailsNonGCFData) => netFormat(row.budRev),
    },
    {
      name: "budOibia",
      header: t("revenue.oibia.grid"),
      render: (row: DetailsNonGCFData) => netFormat(row.budOibia),
    },
    {
      name: "budOibiaMargin",
      header: t("revenue.oibia.margin"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.budOibiaMargin, true),
      isColored: true,
    },
    {
      name: "budTbgRev",
      header: t("revenue.tbg"),
      render: (row: DetailsNonGCFData) => netFormat(row.budTbgRev),
    },
    {
      name: "budTbgOfRev",
      header: t("revenue.tbg.of.revenue"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.budTbgOfRev, true),
      isColored: true,
    },
    {
      name: "budVSCurrRevVar",
      header: t("net.revenue.variance.dollars"),
      render: (row: DetailsNonGCFData) => netFormat(row.budVSCurrRevVar, true),
      isColored: true,
    },
    {
      name: "budVSCurrRevVarPerc",
      header: t("net.revenue.variance.perc"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.budVSCurrRevVarPerc, true),
      isColored: true,
    },
    {
      name: "budVSCurrOibiaVar",
      header: t("oibia.variance"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.budVSCurrOibiaVar, true),
      isColored: true,
    },
    {
      name: "budVSCurrTbgVar",
      header: t("tbg.revenue.variance"),
      render: (row: DetailsNonGCFData) => netFormat(row.budVSCurrTbgVar, true),
      isColored: true,
    },
    {
      name: "currRev",
      header: t("revenue.net.rev"),
      render: (row: DetailsNonGCFData) => netFormat(row.currRev),
    },
    {
      name: "currOibia",
      header: t("revenue.oibia.grid"),
      render: (row: DetailsNonGCFData) => netFormat(row.currOibia),
    },
    {
      name: "currOibiaMargin",
      header: t("revenue.oibia.margin"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.currOibiaMargin, true),
      isColored: true,
    },
    {
      name: "currTbgRev",
      header: t("revenue.tbg"),
      render: (row: DetailsNonGCFData) => netFormat(row.currTbgRev),
    },
    {
      name: "currTbgOfRev",
      header: t("revenue.tbg.of.revenue"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.currTbgOfRev, true),
      isColored: true,
    },
    {
      name: "currVSPrevRevVar",
      header: t("net.revenue.variance.dollars"),
      render: (row: DetailsNonGCFData) => netFormat(row.currVSPrevRevVar, true),
      isColored: true,
    },
    {
      name: "currVSPrevRevVarPerc",
      header: t("net.revenue.variance.perc"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.currVSPrevRevVarPerc, true),
      isColored: true,
    },
    {
      name: "currVSPrevOibiaVar",
      header: t("oibia.variance"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.currVSPrevOibiaVar, true),
      isColored: true,
    },
    {
      name: "currVSPrevTbgVar",
      header: t("tbg.revenue.variance"),
      render: (row: DetailsNonGCFData) => netFormat(row.currVSPrevTbgVar, true),
      isColored: true,
    },
    {
      name: "prevRev",
      header: t("revenue.net.rev"),
      render: (row: DetailsNonGCFData) => netFormat(row.prevRev),
    },
    {
      name: "prevOibia",
      header: t("revenue.oibia.grid"),
      render: (row: DetailsNonGCFData) => netFormat(row.prevOibia),
    },
    {
      name: "prevOibiaMargin",
      header: t("revenue.oibia.margin"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.prevOibiaMargin, true),
      isColored: true,
    },
    {
      name: "prevTbgRev",
      header: t("revenue.tbg"),
      render: (row: DetailsNonGCFData) => netFormat(row.prevTbgRev),
    },
    {
      name: "prevTbgOfRev",
      header: t("revenue.tbg.of.revenue"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.prevTbgOfRev, true),
      isColored: true,
    },
    {
      name: "currVSPrevActRevVar",
      header: t("net.revenue.variance.dollars"),
      render: (row: DetailsNonGCFData) =>
        netFormat(row.currVSPrevActRevVar, true),
      isColored: true,
    },
    {
      name: "currVSPrevActRevVarPerc",
      header: t("net.revenue.variance.perc"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.currVSPrevActRevVarPerc, true),
      isColored: true,
    },
    {
      name: "currVSPrevActOibiaVar",
      header: t("oibia.variance"),
      render: (row: DetailsNonGCFData) =>
        percentanceFormat(row.currVSPrevActOibiaVar, true),
      isColored: true,
    },
    {
      name: "currVSPrevActTbgVar",
      header: t("revenue.tbg.variance"),
      render: (row: DetailsNonGCFData) =>
        netFormat(row.currVSPrevActTbgVar, true),
      isColored: true,
    },
  ] as RowDefinitionType[]
}

export const gcfRow = (t: TType, type: string) => {
  return [
    {
      name: "entityName",
      header: "",
      render: (row: DetailsGCFData, rowId: number) => (
        <EntityNameRenderer type={type} row={row} rowId={rowId} />
      ),
      customWidth: 100,
      align: "start",
    },
    {
      name: "targetRevenue",
      header: t("revenue.usd").toUpperCase(),
      render: (row: DetailsGCFData) => netFormat(row.targetRevenue),
    },
    {
      name: "targetOibia",
      header: t("revenue.oi.percent"),
      render: (row: DetailsGCFData) => percentanceFormat(row.targetOibia),
    },
    {
      name: "targetVSYearToDateRevenueDelta",
      header: "\u0394" + " " + t("revenue.revenue").toUpperCase(),
      render: (row: DetailsGCFData) =>
        percentanceFormat(row.targetVSYearToDateRevenueDelta, true),
      isColored: true,
    },
    {
      name: "targetVSYearToDateOiDelta",
      header: "\u0394" + " " + t("revenue.oi.percent"),
      render: (row: DetailsGCFData) =>
        percentanceFormat(row.targetVSYearToDateOiDelta, true),
      isColored: true,
    },
    {
      name: "ytdRevenue",
      header: t("revenue.usd"),
      render: (row: DetailsGCFData) => netFormat(row.ytdRevenue),
    },
    {
      name: "ytdOibia",
      header: t("revenue.oi.percent"),
      render: (row: DetailsGCFData) => percentanceFormat(row.ytdOibia),
    },
    {
      name: "yearToDateVSPreviousRevenueDelta",
      header: "\u0394" + " " + t("revenue.revenue").toUpperCase(),
      render: (row: DetailsGCFData) =>
        percentanceFormat(row.yearToDateVSPreviousRevenueDelta, true),
      isColored: true,
    },
    {
      name: "yearToDateVSPreviousOiDelta",
      header: "\u0394" + " " + t("revenue.oi.percent"),
      render: (row: DetailsGCFData) =>
        percentanceFormat(row.yearToDateVSPreviousOiDelta, true),
      isColored: true,
    },
    {
      name: "previousScenarioRevenueValue",
      header: t("revenue.usd"),
      render: (row: DetailsGCFData) =>
        netFormat(row.previousScenarioRevenueValue),
    },
    {
      name: "previousScenarioOIPercentage",
      header: t("revenue.oi.percent"),
      render: (row: DetailsGCFData) =>
        percentanceFormat(row.previousScenarioOIPercentage),
    },
    {
      name: "previousVSActualRevenueDelta",
      header: "\u0394" + " " + t("revenue.revenue").toUpperCase(),
      render: (row: DetailsGCFData) =>
        percentanceFormat(row.previousVSActualRevenueDelta, true),
      isColored: true,
    },
    {
      name: "previousVSActualOiDelta",
      header: "\u0394" + " " + t("revenue.oi.percent"),
      render: (row: DetailsGCFData) =>
        percentanceFormat(row.previousVSActualOiDelta, true),
      isColored: true,
    },
  ]
}
